<template>
  <div>
  <div class="explain">
    <div class="use">
      <greentitle titleText="Instructions for use" />
      <div class="content">
        <p>1. Those who book ID card-based tickets can enter the park by showing the ID cards they used to book the tickets.</p>
        <p>2. Those who book QR code-based tickets can enter the park by showing the automatically generated QR code and the ID certificates they used to book the tickets. </p>
      </div>
    </div>
    <div class="use mt-50">
      <greentitle titleText="Refunding policy" />
      <div class="content">
        <p>1. Used tickets are non-refundable. </p>
        <p>2. Unused tickets can be refunded any time prior to the appointed date of visit. </p>
        <p>3. Visitors can apply for refunding for unused tickets within seven days since the appointed date of visit.</p>
      </div>
    </div>
  </div>
</div>

</template>

<script>
export default {
  name: "explain",
  props: {
    itemList: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    showBank: function() {
      let bool = this.itemList.some(item => item.ticketStatus === '2')
      return bool
    }
  }
};
</script>

<style scoped lang='less'>
.explain{
  padding: .293333rem .32rem;
  background: #FFFFFF;
  margin: .333333rem 0.346667rem 0;
  box-shadow: 0 .133333rem .08rem rgba(0, 0, 0, 0.01);
  border-radius: .08rem;
  .use{
    text-align: justify;
    .content{
      font-size: .4rem;
      color: rgba(58, 62, 92, .8);
      margin-top: .266667rem;
    }
  }
  .mt-50{
    margin-top: .666667rem;
  }
  .bank {
    display: block;
    height: 80px;
    margin: 0 auto;
  }
}
</style>
